import React, { useEffect, useState } from "react";
import Layout from "../Common/Layout";
import { FiUser, FiMail, FiPhone, FiShield } from "react-icons/fi";

const Profile = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  if (!user) {
    return (
      <Layout>
        <div className="text-center mt-5">No user data found</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="container mt-4">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card shadow border-0 rounded-4">
              <div className="card-body p-4">
                {/* Avatar */}
                <div className="text-center mb-4">
                  <div
                    className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mx-auto"
                    style={{ width: 90, height: 90, fontSize: 32 }}
                  >
                    {user.name?.charAt(0)}
                  </div>
                  <h4 className="mt-3 fw-bold">{user.name}</h4>
                  <span className="badge bg-success px-3 py-2">
                    {sessionStorage.getItem("role")}{" "}
                  </span>
                </div>

                {/* Profile Details */}
                <ul className="list-group list-group-flush">
                  <li className="list-group-item d-flex align-items-center gap-3">
                    <FiMail />
                    <span>{user.email}</span>
                  </li>

                  <li className="list-group-item d-flex align-items-center gap-3">
                    <FiPhone />
                    <span>{user.phone || "N/A"}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
